import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	type placementRenderProps,
	PlacementFrontend,
} from '@post-office/browser--growth-transmuters/share-and-permissions-modal';

import type { MessageTemplateContext } from '../../../index';

import { useCallback, useEffect } from 'react';

import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<placementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageTemplateContext & placementRenderProps>(),

		Component: ({ startTour }: MessageTemplateContext & placementRenderProps) => {
			const { onClosed } = usePostOfficeUserInteractions();

			const onDismiss = useCallback(() => {
				void onClosed({
					interactionIdentifier: 'tour-dismiss-button',
					additionalMetadata: {},
				});
			}, []);

			useEffect(() => {
				startTour(onDismiss);
			}, [onDismiss]);

			return <></>;
		},
	},
});
